import React from 'react';
import { SeekOption } from '../types';
import { Clock } from 'lucide-react';

interface TimeTravelProps {
  currentSeek: SeekOption | null;
  onSeek: (option: SeekOption) => void;
}

const seekOptions: SeekOption[] = ['-1h', '-3h', '-6h', '-12h', '-24h', '-48h', '-72h'];

export const TimeTravel: React.FC<TimeTravelProps> = ({ currentSeek, onSeek }) => {
  return (
    <div className="w-full py-6">
      <div className="flex items-center gap-2 mb-3 px-1">
        <Clock className="w-4 h-4 text-rutabaga-wood" />
        <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider">Time Travel</h3>
      </div>
      
      <div className="flex gap-3 overflow-x-auto pb-4 no-scrollbar touch-pan-x">
        {seekOptions.map((option) => {
          const isActive = currentSeek === option;
          return (
            <button
              key={option}
              onClick={() => onSeek(option)}
              className={`
                flex-shrink-0 px-4 py-2 rounded-xl font-heading font-bold text-sm transition-all duration-200 border-2
                ${isActive 
                  ? 'bg-rutabaga-wood border-rutabaga-wood text-white shadow-md scale-105' 
                  : 'bg-white border-gray-200 text-gray-500 hover:border-rutabaga-wood hover:text-rutabaga-wood hover:bg-rutabaga-bg'
                }
              `}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
};